export const chartColors = [
    '#8781CA', '#4db797', '#f07023', '#fee378', '#6299eb', '#FFF263', '#337af6', '#FF9655', '#6AF9C4'
];

export const defaultChartColorIndex = 2;

export const maximumDatesInclinometers = 15;

export const INCLINOMETER = 'Inclinometer';

// we don't need min, max, middle for inclinometers for example
export const doNotShowTripleData = false;
// no profiles needed except for piezometers (so far)
export const defaultMeasuringProfile = 0;
